import { Avatar, Box, CardContent, Chip, Typography } from "@mui/material";
import { mdiMapMarkerOutline } from "@mdi/js";
import Icon from "@mdi/react";

import { EventLocation as Location } from "api/event";
import CardWithAvatar from "components/CardWithAvatar";
import googleMapsIcon from "assets/icons/google-map.png";
import wazeIcon from "assets/icons/waze.png";
import styles from "./eventLocation.module.scss";

export interface EventLocationProps {
  location: Location;
}

export default function EventLocation(props: EventLocationProps): JSX.Element {
  const { location } = props;

  /**
   * Handle open location by opening it in a new tab
   *
   * @param type
   */
  function handleOpenLocation(type: "google-maps" | "waze"): void {
    if (location) {
      if (type === "google-maps") {
        window.open(
          `https://www.google.com/maps/search/?api=1&query=${location.coordinates.lat}%2C${location.coordinates.lng}`
        );
      } else if (type === "waze") {
        window.open(`https://www.waze.com/ul?ll=${location.coordinates.lat}%2C${location.coordinates.lng}`);
      }
    }
  }

  return (
    <CardWithAvatar
      data-testid='event-location'
      icon={<Icon path={mdiMapMarkerOutline} size={1.2} />}
      noHeaderGutterBottom
      subheader={location.name}
      title='Location'
    >
      <CardContent>
        <Box mb={1}>
          <Typography variant='body2'>Open with:</Typography>
        </Box>
        <Chip
          avatar={
            <Avatar className={styles.googleMapsAvatar}>
              <img src={googleMapsIcon} alt='icon' />
            </Avatar>
          }
          className={styles.chip}
          label='Google Maps'
          variant='outlined'
          onClick={() => handleOpenLocation("google-maps")}
        />
        <Chip
          avatar={
            <Avatar className={styles.wazeAvatar}>
              <img src={wazeIcon} alt='icon' />
            </Avatar>
          }
          className={styles.chip}
          label='Waze'
          variant='outlined'
          onClick={() => handleOpenLocation("waze")}
        />
      </CardContent>
    </CardWithAvatar>
  );
}
